const Corporate = () => {
  const trustedCompanies = [
    { name: 'Quỹ Đầu Tư Vnham', logo: '/assets/images/partners/vnham.svg' },
    { name: 'Cty Damco', logo: '/assets/images/partners/damco.png' },
    { name: 'BĐS Gotec', logo: '/assets/images/partners/gotecland.png' },
    { name: 'Vietinbank', logo: '/assets/images/partners/vietinbank.png' },
    { name: 'ACB', logo: '/assets/images/partners/acb.svg' },
    { name: 'Vietcombank', logo: '/assets/images/partners/vietcombank.svg' },
    { name: 'FWD', logo: '/assets/images/partners/fwd.svg' },
    { name: 'Manulife', logo: '/assets/images/partners/manulife.png' },
    { name: 'AIA', logo: '/assets/images/partners/aia.png' },
    { name: 'Novaland', logo: '/assets/images/partners/novaland.svg' },
    {
      name: 'Hưng Thịnh Group',
      logo: '/assets/images/partners/hung-thinh.png',
    },
  ];

  const services = [
    {
      title: 'Đào tạo Lãnh đạo',
      description: 'Phát triển kỹ năng lãnh đạo cho đội ngũ quản lý các cấp',
      icon: '👑',
      features: ['Kỹ năng lãnh đạo', 'Quản lý đội nhóm', 'Tư duy chiến lược'],
    },
    {
      title: 'Đào tạo Bán hàng',
      description: 'Nâng cao hiệu quả bán hàng và chăm sóc khách hàng',
      icon: '💼',
      features: [
        'Kỹ thuật bán hàng',
        'Chăm sóc khách hàng',
        'Kỹ năng đàm phán',
      ],
    },
    {
      title: 'Xây dựng Đội nhóm',
      description: 'Tăng cường tinh thần đồng đội và hiệu quả làm việc',
      icon: '👥',
      features: ['Xây dựng đội nhóm', 'Kỹ năng giao tiếp', 'Hợp tác hiệu quả'],
    },
    {
      title: 'Phát triển năng lực đội nhóm',
      description: 'Xây dựng văn hóa doanh nghiệp mạnh mẽ và bền vững',
      icon: '🏢',
      features: [
        'Văn hóa doanh nghiệp',
        'Tích hợp giá trị',
        'Gắn kết nhân viên',
      ],
    },
  ];

  return (
    <section id="corporate" className="section-padding bg-white">
      <div className="container-custom">
        {/* Header */}
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            GIẢI PHÁP ĐÀO TẠO TOÀN DIỆN
          </h2>
          <p className="text-xl text-primary font-semibold mb-4">
            CHO DOANH NGHIỆP
          </p>
          <p className="text-lg text-gray-600 leading-relaxed">
            Upower đồng hành cùng sự phát triển của doanh nghiệp thông qua các
            chương trình đào tạo chuyên biệt, được thiết kế riêng cho từng tổ
            chức.
          </p>
        </div>

        {/* Trusted Companies */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-center text-gray-900 mb-8">
            Được tin tưởng bởi các doanh nghiệp hàng đầu
          </h3>
          <div className="bg-gray-50 rounded-2xl p-8">
            <div className="flex flex-wrap justify-center items-center gap-6">
              {trustedCompanies.map((company, index) => (
                <div
                  key={index}
                  className="bg-white rounded-lg p-4 shadow-sm hover:shadow-md transition-all duration-300 hover:scale-105 flex items-center justify-center min-h-[80px] min-w-[120px]"
                >
                  <img
                    src={company.logo}
                    alt={`${company.name} logo`}
                    className="h-8 md:h-10 object-contain"
                    onError={e => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'block';
                    }}
                  />
                  <div className="text-gray-700 font-semibold text-xs hidden">
                    {company.name}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Services */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:border-primary/30 transition-all duration-300 hover:shadow-xl group"
            >
              <div className="flex items-start mb-6">
                <div className="text-4xl mr-4 group-hover:scale-110 transition-transform duration-300">
                  {service.icon}
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-primary transition-colors duration-300">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </div>

              <div className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <div key={featureIndex} className="flex items-center">
                    <svg
                      className="w-4 h-4 text-primary mr-3 flex-shrink-0"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span className="text-gray-700 text-sm">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Benefits */}
        <div className="bg-gradient-to-r from-primary to-primary-700 rounded-2xl p-8 md:p-12 text-white mb-12">
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl md:text-3xl font-bold mb-6">
                Tại sao chọn UPOWER cho doanh nghiệp?
              </h3>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <svg
                    className="w-6 h-6 text-primary-200 mt-1 mr-3 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="text-primary-100">
                    <strong className="text-white">
                      Chương trình tùy chỉnh:
                    </strong>{' '}
                    Thiết kế riêng cho từng doanh nghiệp
                  </span>
                </li>
                <li className="flex items-start">
                  <svg
                    className="w-6 h-6 text-primary-200 mt-1 mr-3 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="text-primary-100">
                    <strong className="text-white">Đội ngũ chuyên gia:</strong>{' '}
                    Hơn 24 năm kinh nghiệm thực tiễn
                  </span>
                </li>
                <li className="flex items-start">
                  <svg
                    className="w-6 h-6 text-primary-200 mt-1 mr-3 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="text-primary-100">
                    <strong className="text-white">
                      Kết quả đo lường được:
                    </strong>{' '}
                    Theo dõi và đánh giá hiệu quả đào tạo
                  </span>
                </li>
                <li className="flex items-start">
                  <svg
                    className="w-6 h-6 text-primary-200 mt-1 mr-3 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="text-primary-100">
                    <strong className="text-white">Hỗ trợ dài hạn:</strong> Đồng
                    hành sau đào tạo
                  </span>
                </li>
              </ul>
            </div>

            <div className="text-center">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8">
                <h4 className="text-2xl font-bold mb-4">
                  Bắt đầu ngay hôm nay
                </h4>
                <p className="text-primary-100 mb-6">
                  Liên hệ để được tư vấn giải pháp đào tạo phù hợp nhất cho
                  doanh nghiệp của bạn
                </p>
                <button
                  onClick={() => {
                    const element = document.querySelector('#contact-form');
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                  className="bg-white text-primary font-semibold py-3 px-8 rounded-lg hover:bg-gray-100 transition-colors duration-300 w-full"
                >
                  Yêu Cầu Tư Vấn Đào Tạo Doanh Nghiệp
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Corporate;
